import {
  find,
  orderBy,
  reduce,
  pipe,
  negate,
  isEmpty,
  get,
  lowerCase,
} from 'lodash/fp';
import { createSelector } from 'reselect';

const contentsSelector = state => state.data.contents;
const topicsSelector = state => state.data.topics;
const topicIdSelector = (state, id) => id;

const lowerCaseTitle = pipe(get('title'), lowerCase);

export const getTopic = createSelector(
  [topicIdSelector, topicsSelector],
  (topicId, topics) => find({ id: topicId }, topics),
);

export const getContents = createSelector(
  [getTopic, contentsSelector],
  pipe((topic, contents) => {
    // topic might not be available if the page is still loading
    if (!topic) return [];
    return topic.contents.map(contentIdentifier =>
      find(contentIdentifier, contents),
    );
  }, orderBy(lowerCaseTitle, 'asc')),
);

export const allTopicsContents = createSelector(
  topicsSelector,
  reduce((contents, topic) => contents.concat(topic.contents), []),
);

export const allTopics = createSelector(
  topicsSelector,
  orderBy(['featured', lowerCaseTitle], ['desc', 'asc']),
);

export const hasTopics = createSelector(topicsSelector, negate(isEmpty));
